/**
 * List Schema of ResponseRobo
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponseRobo} from '@/model/resource/ResponseRobo'

/* TODO: review generated schema */
export class ListResponseRoboSchema extends Schema {
  readonly name = 'ListResponseRobo'

  readonly fieldSet: FieldSet<ResponseRobo> = {
    idResponsePk: (): FieldComponent => ({
      is: Component.Render,
    }),
    danfe: (): FieldComponent => ({
      is: Component.Render,
    }),
    response: (): FieldComponent => ({
      is: Component.Render,
    }),
    ehCte: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ehCte),
      },
    }),
  }
}
